"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THERAPIST_STATUS = void 0;
var THERAPIST_STATUS;
(function (THERAPIST_STATUS) {
    // This is the default for a normal working therapist.
    THERAPIST_STATUS[THERAPIST_STATUS["ACTIVE"] = 0] = "ACTIVE";
    // A therapist we are ending the cooperation with.
    // We want them to finish booked events with current clients.
    // We do not want them to acquire new clients, so we set visible = false
    // and "lock" their settings so they cannot change it back.
    // We do not want to promote them in any way.
    THERAPIST_STATUS[THERAPIST_STATUS["LOCKED"] = 1] = "LOCKED";
    // Almost same as active, but we do not want to promote them.
    THERAPIST_STATUS[THERAPIST_STATUS["SHADOW_BANNED"] = 2] = "SHADOW_BANNED";
    // Same as active, but we want to promote them more.
    THERAPIST_STATUS[THERAPIST_STATUS["BOOSTED"] = 3] = "BOOSTED";
    // A therapist that is not active yet, but probably will be (we have not started the cooperation yet).
    THERAPIST_STATUS[THERAPIST_STATUS["NOT_ACTIVATED"] = 4] = "NOT_ACTIVATED";
    // This is for dev/product testing purposes only (even in the production environment)! Not for public/production use!
    THERAPIST_STATUS[THERAPIST_STATUS["TESTING"] = 5] = "TESTING";
    // A therapist that we ended cooperation with. Same behaviour as LOCKED.
    THERAPIST_STATUS[THERAPIST_STATUS["TERMINATED"] = 6] = "TERMINATED";
    // A therapist that ended cooperation with us. Same behaviour as LOCKED.
    THERAPIST_STATUS[THERAPIST_STATUS["RESIGNED"] = 7] = "RESIGNED";
})(THERAPIST_STATUS || (exports.THERAPIST_STATUS = THERAPIST_STATUS = {}));
